import { initializeApp } from "firebase/app";
import { getFirestore } from "@firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyApVwTUSRCxAz_n4F_TOlH2wlI0yNBLA48",
    authDomain: "catalogoadmin-b6f3b.firebaseapp.com",
    projectId: "catalogoadmin-b6f3b",
    storageBucket: "catalogoadmin-b6f3b.appspot.com",
    messagingSenderId: "222346550001",
    appId: "1:222346550001:web:34b53f7474da21f8466750",
    measurementId: "G-VQ9X0N1Q22"
  };

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app)
export const storage = getStorage(app)
export const auth = getAuth(app)